// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font {
  background-color: #000215;
  color: #fefcf9;
  width: 100%;
  min-height: calc(100vh - 50px) !important;
  overflow: hidden;
  border: 1px solid rgb(0, 0, 0);
  overflow: auto;
}

.date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000215;
  color: #fefcf9;
  height: 50px;
  font-style: italic;
  margin-bottom: 0;
}

.nogame-card::before {
  content: "";
  display: block;
  height: 3px;
  border-radius: 999px;
  margin-bottom: 14px;
  background: linear-gradient(90deg, rgba(120, 170, 255, 0.9), rgba(255, 170, 120, 0.8));
  opacity: 0.9;
}

.nogame-wrap {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  padding: 24px;
}

.nogame-card {
  width: min(520px, 92vw);
  padding: 26px 28px;
  border-radius: 18px;
  background: rgba(18, 22, 40, 0.55);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45), 0 1px 0 rgba(255, 255, 255, 0.06) inset;
  text-align: center;
  animation: popIn 180ms ease-out;
}

.nogame-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}
.nogame-title .emoji {
  font-size: 22px;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.35));
}
.nogame-title h2 {
  margin: 0;
  font-weight: 800;
  letter-spacing: 0.2px;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.92);
}

.nogame-sub {
  margin: 8px 0 18px;
  font-size: 14px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.7);
}

.nogame-tip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 13px;
  color: rgba(120, 170, 255, 0.95);
}
.nogame-tip .hand {
  font-size: 15px;
}

@keyframes popIn {
  from {
    transform: translateY(6px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
/* Mobile: un peu plus compact */
@media (max-width: 480px) {
  .nogame-card {
    padding: 18px 18px;
    border-radius: 16px;
  }
  .nogame-title h2 {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/nogame/nogame.component.scss","webpack://./src/utilities/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBCHY;EDIZ,cAAA;EACA,WAAA;EACA,yCAAA;EACA,gBAAA;EACA,8BAAA;EACA,cAAA;AADF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBCfY;EDgBZ,cAAA;EACA,YCZc;EDad,kBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,sFAAA;EACA,YAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AACA;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,kCAAA;EACA,2BAAA;EACA,mCAAA;EAEA,2CAAA;EACA,oFACE;EAGF,kBAAA;EAGA,+BAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AANF;AAQE;EACE,eAAA;EACA,mDAAA;AANJ;AASE;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gCAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AARF;;AAWA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,qCAAA;EACA,2CAAA;EAEA,eAAA;EACA,gCAAA;AAXF;AAaE;EAAQ,eAAA;AAVV;;AAaA;EACE;IAAO,sCAAA;IAAwC,UAAA;EAR/C;EASA;IAAO,iCAAA;IAAwC,UAAA;EAL/C;AACF;AAOA,gCAAA;AACA;EACE;IAAe,kBAAA;IAAoB,mBAAA;EAHnC;EAIA;IAAmB,eAAA;EADnB;AACF","sourcesContent":["@import \"/src/utilities/variables\";\r\n\r\n.font {\r\n  background-color: $color_black;\r\n  color: #fefcf9;\r\n  width: 100%;\r\n  min-height: calc(100vh - $header_height) !important;\r\n  overflow: hidden;\r\n  border: 1px solid rgb(0, 0, 0);\r\n  overflow: auto;\r\n}\r\n.date {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: $color_black;\r\n  color: #fefcf9;\r\n  height: $header_height;\r\n  font-style: italic;\r\n  margin-bottom: 0;\r\n}\r\n.nogame-card::before{\r\n  content:\"\";\r\n  display:block;\r\n  height:3px;\r\n  border-radius: 999px;\r\n  margin-bottom: 14px;\r\n  background: linear-gradient(90deg, rgba(120,170,255,.9), rgba(255,170,120,.8));\r\n  opacity: .9;\r\n}\r\n.nogame-wrap {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 24px;\r\n}\r\n\r\n.nogame-card {\r\n  width: min(520px, 92vw);\r\n  padding: 26px 28px;\r\n  border-radius: 18px;\r\n\r\n  // glass + cohérent avec ton fond\r\n  background: rgba(18, 22, 40, 0.55);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n  box-shadow:\r\n    0 16px 40px rgba(0, 0, 0, 0.45),\r\n    0 1px 0 rgba(255, 255, 255, 0.06) inset;\r\n\r\n  text-align: center;\r\n\r\n  // petite anim d’entrée\r\n  animation: popIn 180ms ease-out;\r\n}\r\n\r\n.nogame-title {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n\r\n  .emoji {\r\n    font-size: 22px;\r\n    filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.35));\r\n  }\r\n\r\n  h2 {\r\n    margin: 0;\r\n    font-weight: 800;\r\n    letter-spacing: 0.2px;\r\n    font-size: 22px;\r\n    color: rgba(255, 255, 255, 0.92);\r\n  }\r\n}\r\n\r\n.nogame-sub {\r\n  margin: 8px 0 18px;\r\n  font-size: 14px;\r\n  line-height: 1.45;\r\n  color: rgba(255, 255, 255, 0.70);\r\n}\r\n\r\n.nogame-tip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n\r\n  padding: 10px 12px;\r\n  border-radius: 12px;\r\n\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border: 1px solid rgba(255, 255, 255, 0.06);\r\n\r\n  font-size: 13px;\r\n  color: rgba(120, 170, 255, 0.95);\r\n\r\n  .hand { font-size: 15px; }\r\n}\r\n\r\n@keyframes popIn {\r\n  from { transform: translateY(6px) scale(0.98); opacity: 0.0; }\r\n  to   { transform: translateY(0)   scale(1);    opacity: 1; }\r\n}\r\n\r\n/* Mobile: un peu plus compact */\r\n@media (max-width: 480px) {\r\n  .nogame-card { padding: 18px 18px; border-radius: 16px; }\r\n  .nogame-title h2 { font-size: 18px; }\r\n}\r\n","$color_black: #000215;\r\n$color_dark_blue: #011d44;\r\n$color_light_blue: #81c0e4;\r\n$color_purple: #c4c5ea;\r\n$color_white: #fefcf9;\r\n$header_height: 50px;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
